export class Constants
{
	public static readonly GCAT_COGNITIVE: string = "cognitive";
	public static readonly GCAT_COORDINATION: string = "coordination";
}